<template>
  <div>
    <br />
    <vs-row vs-justify="center">
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="12" vs-xs="12">
        <div>
          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <fieldset class="material">
                <input
                  v-model="form.nombre"
                  @blur="$v.form.nombre.$touch()"
                  :danger="erroresNombre&&true"
                  type="text"
                  placeholder="Nombres Completos"
                  autocomplete="off"
                  required
                />

                <label>Nombres Completos</label>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                  <span class="span-text-validation" v-text="erroresNombre"></span>
                </div>
              </fieldset>
            </vs-col>
          </vs-row>

          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <fieldset class="material">
                <input
                  v-model="form.wspp"
                  @blur="$v.form.wspp.$touch()"
                  :danger="erroresWhatsapp&&true"
                  type="text"
                  placeholder="Whatsapp"
                  autocomplete="off"
                  required
                />

                <label>Whatsapp</label>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                  <span class="span-text-validation" v-text="erroresWhatsapp"></span>
                </div>
              </fieldset>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <fieldset class="material">
                <input
                  v-model="form.correo"
                  @blur="$v.form.correo.$touch()"
                  :danger="erroresCorreo&&true"
                  type="text"
                  placeholder="Correo"
                  autocomplete="off"
                  required
                />

                <label>Correo</label>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                  <span class="span-text-validation" v-text="erroresCorreo"></span>
                </div>
              </fieldset>
            </vs-col>
          </vs-row>
          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <fieldset class="material">
                <input
                  v-model="form.observacion"
                  @blur="$v.form.observacion.$touch()"
                  :danger="erroresObservacion&&true"
                  type="text"
                  placeholder="Observacion"
                  autocomplete="off"
                  required
                />

                <label>Observacion</label>
                <div
                  class="con-text-validation span-text-validation-danger vs-input--text-validation-span"
                >
                  <span class="span-text-validation" v-text="erroresObservacion"></span>
                </div>
              </fieldset>
            </vs-col>
          </vs-row>

          <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-lg="12" vs-sm="12" vs-xs="12">
              <button
                v-if="msj==false"
                :depressed="$v.form.$invalid"
                :disabled="$v.form.$invalid||prevent"
                @click="guardarDatos()"
                class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent"
              >Enviar</button>

              <button
                v-else
                disabled
                class="mdl-button mdl-js-button mdl-button--raised mdl-button--accent"
              >Informacion Enviada Correctamente!</button>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>
 
<script>
import "material-design-lite/material.min.css";

import { nombreCompuesto } from "@/utils/validaciones";
import {
  email,
  required,
  numeric,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import prefijos from "@/utils/prefijos";
import { db } from "@/plugins/firebase";

export default {
  name: "Formulario",
  data() {
    return {
      msj: false,
      prevent: false,
      form: {
        nombre: "",
        pais: +51,
        wspp: "",
        correo: "",
        observacion: "",
      },
      paises: [],
    };
  },
  validations: {
    form: {
      nombre: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(45),
        nombreCompuesto,
      },
      pais: {
        required,
      },
      wspp: {
        required,
        minLength: minLength(9),
        maxLength: maxLength(12),
        numeric,
      },
      correo: {
        email,
        required,
      },
      observacion: {
        minLength: minLength(10),
        maxLength: maxLength(400),
      },
    },
  },
  methods: {
    async guardarDatos() {
      this.prevent = true;
      try {
        let usuario = {
          uid: this.uid(),
          nombres: this.form.nombre,
          pais: this.form.pais,
          wspp: this.form.wspp,
          correo: this.form.correo,
          observacion: this.form.observacion,
          fecha: new Date(),
        };

        let batch = db.batch();
        batch.set(db.collection("usuarios").doc(usuario.uid), usuario);

        await batch.commit();
        this.msj = true;
      } catch (error) {
        console.log(error);
      } finally {
        this.prevent = false;
      }
    },
    clean() {
      // this.form.nombre = "";
      // this.form.wspp = "";
      //this.form.correo = "";
      // this.form.observacion = "";
      setTimeout(function () {
        this.msj = false;
      }, 2000);
    },
    uid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    head_script(src) {
      if (document.querySelector("script[src='" + src + "']")) {
        return;
      }
      let script = document.createElement("script");
      script.setAttribute("src", src);
      script.setAttribute("type", "text/javascript");
      document.head.appendChild(script);
    },
  },
  computed: {
    erroresNombre() {
      if (!this.$v.form.nombre.$dirty) {
        return "";
      }
      if (!this.$v.form.nombre.required) {
        return "Ingresa tus Nombres Completos";
      }
      if (!this.$v.form.nombre.minLength) {
        return "Ingresa al menos 3 caracteres";
      }
      if (!this.$v.form.nombre.maxLength) {
        return "Ingresa maximo 45 caracteres";
      }
      if (!this.$v.form.nombre.nombreCompuesto) {
        return "Ingresa un Nombre Válido";
      }
    },

    erroresWhatsapp() {
      if (!this.$v.form.wspp.$dirty) {
        return "";
      }
      if (!this.$v.form.wspp.required) {
        return "Whatsapp es Requerido";
      }

      if (!this.$v.form.wspp.minLength) {
        return "Ingresa al menos 9 caracteres";
      }

      if (!this.$v.form.wspp.maxLength) {
        return "Ingresa maximo 12 caracteres";
      }
      if (!this.$v.form.wspp.numeric) {
        return "Ingresa un Whatsapp Válido";
      }
    },

    erroresCorreo() {
      if (!this.$v.form.correo.$dirty) {
        return "";
      }
      if (!this.$v.form.correo.required) {
        return "correo es Requerido";
      }
      if (!this.$v.form.correo.email) {
        return "Ingresa un correo Válido";
      }
    },
    erroresObservacion() {
      if (!this.$v.form.observacion.$dirty) {
        return "";
      }

      if (!this.$v.form.observacion.minLength) {
        return "Ingresa al menos 10 caracteres";
      }

      if (!this.$v.form.observacion.maxLength) {
        return "Ingresa maximo 400 caracteres";
      }
    },
  },
  mounted() {
    this.paises = prefijos;
  },
};
</script>
<style>
* {
  font-family: Arial;
}

.con-vs-alert {
  height: 35px !important;
}

.con-text-validation .span-text-validation {
  padding: 0px 4px;
  padding-bottom: 1px;
}

.material {
  position: relative;
  padding: 0;
  margin: 5px;
  border: none;
  overflow: visible;
}
.material input {
  box-sizing: border-box;
  width: 100%;
  padding: 6px 10px 8px;
  border: none;
  border-radius: 0;
  box-shadow: none;
  border-bottom: 1px solid #ddd;
  font-size: 122%;
  outline: none;
  cursor: text;
}
.material input::-webkit-input-placeholder {
  transition: color 300ms ease;
}
.material input:not(:focus)::-webkit-input-placeholder {
  color: transparent;
}
.material hr {
  content: "";
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 2px;
  border: none;
  background: #00a6f0;
  font-size: 1px;
  will-change: transform, visibility;
  transition: all 200ms ease-out;
  transform: scaleX(0);
  visibility: hidden;
  z-index: 10;
}
.material input:focus ~ hr {
  transform: scaleX(1);
  visibility: visible;
}
.material label {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 120%;
  color: #00a6f0;
  transform-origin: 0 -150%;
  transition: transform 300ms ease;
  pointer-events: none;
}
.material input:focus ~ label,
.material input:valid ~ label {
  transform: scale(0.6);
}
</style>
